import { ScrollPanelDesignTokens } from '@primeuix/themes/types/scrollpanel';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/scrollpanel/index.ts
const sp = componentCommon.scrollpanel;
const spCs = componentColorScheme.scrollpanel;

export const ScrollpanelTelekomDT: ScrollPanelDesignTokens = {
  bar: {
    size: t(sp.bar.size),
    borderRadius: t(sp.bar.border.radius),
    focusRing: {
      width: t(sp.bar.focus.ring.width),
      offset: t(sp.bar.focus.ring.offset),
      color: t(sp.bar.focus.ring.color),
    },
  },
  colorScheme: {
    light: {
      bar: {
        background: t(spCs.bar.background),
      },
    },
  },
};
